import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center mb-6"
}

import { useDisplay, useGoTo } from 'vuetify'


export default /*@__PURE__*/_defineComponent({
  __name: 'ScrollHero',
  setup(__props) {

const { mobile: isMobile } = useDisplay()
const goTo = useGoTo()

function scrollHero() {
  goTo('#scroll')
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (!_unref(isMobile))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_v_btn, {
          id: "heroScrollBtn",
          onClick: scrollHero,
          variant: "outlined",
          color: "white",
          icon: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, null, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createTextVNode("mdi-chevron-down")
              ])),
              _: 1
            })
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})